var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteDate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6665 4.16667C4.20627 4.16667 3.83317 4.53976 3.83317 5V16.6667C3.83317 17.1269 4.20627 17.5 4.6665 17.5H16.3332C16.7934 17.5 17.1665 17.1269 17.1665 16.6667V5C17.1665 4.53976 16.7934 4.16667 16.3332 4.16667H4.6665ZM2.1665 5C2.1665 3.61929 3.28579 2.5 4.6665 2.5H16.3332C17.7139 2.5 18.8332 3.61929 18.8332 5V16.6667C18.8332 18.0474 17.7139 19.1667 16.3332 19.1667H4.6665C3.28579 19.1667 2.1665 18.0474 2.1665 16.6667V5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8333 0.833252C14.2936 0.833252 14.6667 1.20635 14.6667 1.66659V4.99992C14.6667 5.46016 14.2936 5.83325 13.8333 5.83325C13.3731 5.83325 13 5.46016 13 4.99992V1.66659C13 1.20635 13.3731 0.833252 13.8333 0.833252Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16683 0.833252C7.62707 0.833252 8.00016 1.20635 8.00016 1.66659V4.99992C8.00016 5.46016 7.62707 5.83325 7.16683 5.83325C6.70659 5.83325 6.3335 5.46016 6.3335 4.99992V1.66659C6.3335 1.20635 6.70659 0.833252 7.16683 0.833252Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1665 8.33333C2.1665 7.8731 2.5396 7.5 2.99984 7.5H17.9998C18.4601 7.5 18.8332 7.8731 18.8332 8.33333C18.8332 8.79357 18.4601 9.16667 17.9998 9.16667H2.99984C2.5396 9.16667 2.1665 8.79357 2.1665 8.33333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDate);
export default __webpack_public_path__ + "static/media/white-date.b89046935f8b8d3004fbceb45ab0d374.svg";
export { ForwardRef as ReactComponent };